import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import TuneIcon from '@mui/icons-material/Tune';

import pageTitle from '../utils/pageTitles.json';
import AdminSettingTable from 'src/sections/adminSetting/adminSettingList/AdminSettingTable';

const MainSection = styled('div')(({ theme }) => ({
  padding: '64px 24px 24px 90px',
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.down('sm')]: {
    padding: '56px 14px 14px 14px',
  },
}));

const HeadingSection = styled('div')(() => ({
  width: '100%',
  padding: '20px 0px 24px 0px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '16px',
}));

const AdminSettingList = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{`${pageTitle?.AdminSettingList || 'Admin Setting List'}`}</title>
      </Helmet>

      <MainSection>
        <HeadingSection>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'primary.lighter',
                color: 'primary.main',
              }}
            >
              <TuneIcon fontSize="medium" />
            </Box>
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 700, color: 'text.primary' }}>
                Admin Setting List
              </Typography>
              <Typography variant="body2" color="text.secondary">
                View, filter, and inspect historical admin setting configurations and campaign snapshots.
              </Typography> 
            </Box>
          </Box>

          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => navigate('/voiceAdminSetting')}
            sx={{ fontWeight: 600, px: 2.5 }}
          >
            Create Admin Setting
          </Button>
        </HeadingSection>

        <AdminSettingTable />
      </MainSection>
    </>
  );
};

export default AdminSettingList;
